export default import.meta.ROLLUP_FILE_URL_CvuQX3F6;